import { Checkbox, Typography, useTheme } from '@mui/material';

import { Flex } from 'src/components/Flex';

interface SupportingDocumentCheckboxProps {
    onSelect: () => void;
    label: string;
    isSelected: boolean;
    subtext?: string;
}

const SupportingDocumentCheckbox = ({
    onSelect,
    label,
    isSelected,
    subtext,
}: SupportingDocumentCheckboxProps) => {
    const theme = useTheme();
    return (
        <Flex alignItems="center" onClick={onSelect}>
            <Checkbox sx={{ paddingLeft: '0px' }} checked={isSelected} />
            <Flex alignItems="baseline" flexDirection="column" color={theme.palette.dark.main}>
                <Typography
                    textTransform="capitalize"
                    fontSize="14px"
                    lineHeight="21px"
                    fontWeight="400"
                >
                    {label}
                </Typography>
                {subtext && <Typography fontSize="12px">{subtext}</Typography>}
            </Flex>
        </Flex>
    );
};

export default SupportingDocumentCheckbox;
